import Script from 'next/script';
import { useEffect, useState } from 'react';

export const ONETRUST_READY_EVENT_NAME = 'onetrustready';

export const WithTracking = ({
  tealiumSrc,
  children,
}: {
  tealiumSrc?: string;
  children: React.ReactNode;
}) => {
  const [consent, setConsent] = useState(false);

  const requiredConsent = ['C0002', 'C0004'];

  function loadTealiumScript() {
    // Check if script is already loaded
    if (document.querySelector('script[src*="utag.js"]')) {
      return;
    }

    // Create and append script element
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = tealiumSrc || '';
    script.id = 'tealium_script';
    document.body?.append(script);
  }

  function removeTealiumScript() {
    const tealiumScript = document.getElementById('tealium_script');

    tealiumScript?.remove();
  }

  function handleOptanonReady() {
    if (!window.OnetrustActiveGroups) {
      setTimeout(handleOptanonReady, 1000);

      return;
    }

    const activeGroups = window.OnetrustActiveGroups.split(',');

    function hasConsent(categories: string[]) {
      return categories.some((category) => requiredConsent.some((group) => group === category));
    }

    const userConsent = hasConsent(activeGroups);

    setConsent(userConsent);

    window.OneTrust.OnConsentChanged(({ detail }: { detail: string[] }) => {
      const userConsent = hasConsent(detail);

      setConsent(userConsent);
    });
  }

  useEffect(() => {
    handleOptanonReady();
  }, [handleOptanonReady]);

  useEffect(() => {
    if (consent) {
      loadTealiumScript();
    } else {
      removeTealiumScript();
    }
  }, [consent, loadTealiumScript, removeTealiumScript]);

  return (
    <>
      {tealiumSrc && consent && (
        <>
          <Script
            type="text/javascript"
            id="utag_data"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
              __html:
                'var utag_data = { };window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};window.utag_cfg_ovrd.noview = true',
            }}
          />
        </>
      )}
      {children}
    </>
  );
};
